// React
import React from 'react';

// Reactstrap
import { Card, Col, Row } from 'reactstrap';

// Containers Injection
import {
  FloatButton,
  PageWrapper,
  DropdownDatatable,
} from '../../containers/componentsInjection';

export const ServicesListPage = ({
  columns,
  history,
  services,
  handleEdit,
  handleDelete,
}) => {
  return (
    <PageWrapper title={'Serviços'}>
      <Row>
        <Col xs={12}>
          <Card>
            <DropdownDatatable
              title="Serviços"
              isCard={false}
              titleButton="Novo serviço"
              columns={columns}
              data={services ? services : []}
              pagination
              persistTableHead
              perPage={10}
              isSearchRemote={false}
              actions={[
                {
                  id: 1,
                  name: 'edit',
                  label: 'Editar',
                  onPress: (cellProps) => handleEdit(cellProps),
                  icon: 'la-pen',
                  classNameColorIcon: 'primary',
                },
              ]}
              handleDelete={(cellProps) => handleDelete(cellProps)}
            />
          </Card>
        </Col>
      </Row>

      <FloatButton handleButton={() => history.push(`/servicos/novo`)} />
    </PageWrapper>
  );
};
